import React from "react";

const LANGUAGE_STORAGE_KEY = "preferredLanguage";

const LangDropdown = (props) => {
  const savedLanguage =
    localStorage.getItem(LANGUAGE_STORAGE_KEY) ||
    localStorage.getItem("i18nextLng") ||
    "en";

  return (
    <select
      onChange={props.onChange}
      aria-label="Select language"
      defaultValue={savedLanguage}
    >
      <option value="" disabled>
        Lang
      </option>
      <option value="en">EN</option>
      <option value="uzb">UZB</option>
      <option value="russ">RUSS</option>
    </select>
  );
};

export default LangDropdown;
